module.exports = __webpack_public_path__ + "static/nyc.0da8df0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/landing-page/nyc.png
// module id = 1595
// module chunks = 221374088121123